import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"minus\">\n<path d=\"M3.60001 8.80001H12.4C12.8423 8.80001 13.2 8.44201 13.2 7.99976C13.2 7.55751 12.8423 7.20001 12.4 7.20001H3.60001C3.15776 7.20001 2.80001 7.55751 2.80001 7.99976C2.80001 8.44201 3.15751 8.80001 3.60001 8.80001Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol